import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { Flex } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { BodyText, TitleText } from 'styling/Typography'
import { IShiftProgramState } from 'types/operationShiftPrograms.interface'

export const Review = ({ setStep, state, handleSave }: { setStep: (step: number) => void, state: IShiftProgramState, handleSave: () => void }) => {
    const handleBack = () => setStep(4)

    return <>
        <Flex column gap='1rem' >
            <Container>
                <ContainerHeader>
                    <TitleText>Identity</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <Flex column gap='1rem'>
                        <Flex gap='5rem' >
                            <BodyText grey >NAME</BodyText>
                            <BodyText  >{state.name} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >NOTES</BodyText>
                            <BodyText  >{state.notes} </BodyText>
                        </Flex>
                    </Flex>
                </ContainerContent>
            </Container>
            <Container>
                <ContainerHeader>
                    <TitleText>Scope</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <Flex column gap='1rem'>
                        <Flex gap='5rem' >
                            <BodyText grey >Site</BodyText>
                            <BodyText  >{state.site?.label} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >TEAMS</BodyText>
                            <BodyText  >{state.teams.map((team: any) => team.label).join(', ')} </BodyText>
                        </Flex>
                    </Flex>
                </ContainerContent>
            </Container>
            <Container>
                <ContainerHeader>
                    <TitleText>Recurrence</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <Flex column gap='1rem'>
                        <Flex gap='5rem' >
                            <BodyText grey >FREQUENCY</BodyText>
                            <BodyText  >{state.frequencyType} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >CADENCE</BodyText>
                            <BodyText  >{state.customIntervalDays} {state.frequencyType === 'custom' ? 'days' : state.frequencyType === 'daily' ? 'day' : state.frequencyType === 'weekly' ? 'week' : ''} </BodyText>
                        </Flex>
                        <Flex gap='5rem' >
                            <BodyText grey >SHIFTS</BodyText>
                            <BodyText  >{state.shifts.map((shift: any) => shift.label).join(', ')} </BodyText>
                        </Flex>
                    </Flex>
                </ContainerContent>
            </Container>
            <Container>
                <ContainerHeader>
                    <TitleText>Task Bindings</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    {state.bindings.map((binding: any) => (
                        <Flex key={binding.id} column gap='1rem'>
                            <Flex gap='5rem' >
                                <BodyText grey >NAME</BodyText>
                                <BodyText  >{binding.taskTemplate?.label} </BodyText>
                            </Flex>
                            <Flex gap='5rem' >
                                <BodyText grey >LOCATIONS</BodyText>
                                <BodyText  >{binding.locations.map((location: any) => location.label).join(', ')} </BodyText>
                            </Flex>
                            <Flex gap='5rem' >
                                <BodyText grey >WORKERS PER LOCATION</BodyText>
                                <BodyText  >{binding.workersPerLocation || 1} </BodyText>
                            </Flex>
                        </Flex>
                    ))}

                </ContainerContent>
            </Container>

        </Flex>
        <Flex gap='1rem' alignEnd justend mt='32' >
            <Button variant='secondary' onClick={handleBack}>Back</Button>
            <Button variant='primary' onClick={handleSave} >Save</Button>
        </Flex>
    </>
}